export interface ClearPendingPaymentDialogResult {
  responseFile: string | null;
}

export interface ClearPendingTransactionBody {
  transactionId: number;
  responseFile: string | null;
}

